import { streamAppAPI } from "../../utils/api/streamUtil";

const generateTechnicalAnalysis = (isin, setAnalysisData, setIsLoading, setThoughtTime) => {

    const onMessage = (data) => {
        setAnalysisData((prev) => prev + data);
        setIsLoading(false)
    }

    const onClose = (start, end) => {
        const seconds = ((end - start) / 1000).toFixed(2);
        setThoughtTime(seconds)
    }

    const params = "/sense/technical/" + isin
    return streamAppAPI(params, onMessage, onClose);
}

export {
    generateTechnicalAnalysis
}